import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  usePatientCategoryListQuery,
  useScenarioPatientCategoryMapQuery,
} from '../../network/queries';
import { Loader } from '../common';

import PatientCategoryTableRow from './PatientCategoryTableRow';

function PatientCategoryTable({ scenarioId }) {
  const { t } = useTranslation();
  // TODO: investigate performance drawbacks of fetching patient category list
  const {
    isLoading: isLoadingBasePatientCategories,
    data: basePatientCategories,
  } = usePatientCategoryListQuery();
  const { isLoading: isLoadingPatientCategoryMap, data: patientCategoryMap } =
    useScenarioPatientCategoryMapQuery(scenarioId);

  return isLoadingBasePatientCategories || isLoadingPatientCategoryMap ? (
    <Loader />
  ) : (
    <Card variant="outlined">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '40px' }} />
              <TableCell sx={{ width: '100%' }}>
                {t('components.patientCategoryMap.name')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {patientCategoryMap.map((patientCategory) => {
              const basePatientCategory = basePatientCategories.find(
                (i) => i.id === patientCategory.id,
              );
              return (
                <PatientCategoryTableRow
                  key={patientCategory.id}
                  basePatientCategory={basePatientCategory}
                  patientCategory={patientCategory}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default PatientCategoryTable;
